import styled from 'styled-components';

export const StyledWrapper = styled.div`
    height: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledLinkWrapper = styled.a`
    margin: 0 15px;
    height: 16px;
    width: 16px;
    color: ${({ theme }) => theme.colors.charcoal100};
`;

export default StyledWrapper;
